<template>
  <header class="inline flex items-center justify-end gap-3">
    <!-- QR code removed: personalized QR removed on the Photodrop "For You" tab
    <BaseButton
      v-if="isMyPhotosTab && !isGICPage && !isSelectingPhotos"
      solid-classes="qr-button text-lightblue bg-grey-5 !text-[14px] !leading-[20px] rounded-[100px] items-center h-9"
      data-test-id="gensapp-photodrop-toggleqr"
      @click="toggleQr"
    >
      <img src="/assets/icons/qr-icon.svg" class="cursor-pointer w-6 h-6 mr-2" alt="QR icon" />
      {{ $t('copy.photoDropPage.photoDropActionBar.myQR') }}
    </BaseButton>
    -->
    <slot />
    <BaseButton
      type="outline"
      class="select-multiple-button !text-[14px] !leading-[20px] !rounded-[100px] items-center h-9"
      :class="textColour"
      :disabled="contentLoading || (isPhotosEmpty && !isSelectingPhotos)"
      @click="toggleSelect"
    >
      {{
        isSelectingPhotos
          ? $t('copy.photoDropPage.photoDropActionBar.cancel')
          : $t('copy.photoDropPage.photoDropActionBar.select')
      }}
    </BaseButton>
  </header>
</template>

<script>
import { mapState } from 'vuex';
import BaseButton from '../../components/common/BaseButton.vue';
import { isGICPage } from '@/utils/conference-type';

export default {
  components: {
    BaseButton,
  },
  props: {
    isMyPhotosTab: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('photos', [
      'isSelectingPhotos',
      'selectedPhotos',
      'isShowQr',
      'photos',
      'everyonePhotos',
      'contentLoading',
    ]),
    isPhotosEmpty() {
      // Check both photos arrays since this header is used on multiple tabs
      return this.photos.length === 0 && this.everyonePhotos.length === 0;
    },
    textColour() {
      const _ = this.$route.path; // reference $route so this computed recomputes on navigation
      const gic = isGICPage();

      // If content is loading or no photos and not currently selecting, show disabled state
      if (this.contentLoading || (this.isPhotosEmpty && !this.isSelectingPhotos)) {
        return '!bg-grey-5 !text-grey-40 cursor-not-allowed';
      }

      if (gic) {
        return '!bg-orange text-white';
      } else {
        return '!bg-lightblue text-white';
      }
    },
  },
  methods: {
    onNavClick() {
      if (this.isShowQr) this.toggleQr();
      else if (this.isSelectingPhotos) this.removeSelect();
      else this.navigateToHome();
    },
    toggleSelect() {
      this.$store.dispatch('photos/updateIsSelectingPhotos', !this.isSelectingPhotos);
      this.$store.dispatch('photos/resetSelectedPhotos');
    },
    removeSelect() {
      this.$store.dispatch('photos/updateIsSelectingPhotos', false);
      this.$store.dispatch('photos/resetSelectedPhotos');
    },
    toggleQr() {
      this.$store.dispatch('photos/updateIsShowQr', true);
      this.$emit('open-modal');
    },
    navigateToHome() {
      this.$router.push('/');
    },
  },
};
</script>

<style scoped></style>
